import { AlertTriangle, CheckCircle2, Info, XCircle } from 'lucide-react';

const ICONS = { success: CheckCircle2, warning: AlertTriangle, danger: XCircle, info: Info };

/**
 * Inline, section-level status message. Status colors are fixed (success,
 * warning, danger, info) and never pharmacy-branded, so meaning stays
 * consistent across every pharmacy theme.
 */
export const PortalInlineAlert = ({ status = 'info', title, children, action, testId }) => {
  const Icon = ICONS[status] || Info;
  return (
    <div
      className={`portal-inline-alert portal-inline-alert-${status}`}
      role={status === 'danger' ? 'alert' : 'status'}
      data-testid={testId || `portal-inline-alert-${status}`}
    >
      <Icon size={18} aria-hidden="true" className="portal-inline-alert-icon" />
      <div className="portal-inline-alert-body">
        {title && <strong>{title}</strong>}
        {children && <p>{children}</p>}
      </div>
      {action}
    </div>
  );
};
